import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import React, {useState} from "react";

const MobileSearch = ({closeMobileMenu}) => {
  const {t} = useTranslation()
  const navigate = useNavigate(); // Use useNavigate to access navigation function
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  // const handleClick = () => {
  //   // Toggle the search form visibility
  //   setIsSearchOpen(!isSearchOpen);
  // };

  const handleSearch = (e) => {
    e.preventDefault();
    closeMobileMenu();
    navigate(`/shop-grid-no-sidebar?search=${searchQuery}`);
    setIsSearchOpen(!isSearchOpen);
  };

  return (
    <div className="offcanvas-mobile-search-area">
      <div className="search-container">
        <form onSubmit={handleSearch}>
          <input
            type="text"
            placeholder={t("Enter Keyword")}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button className="button-search" type="submit">
            <i className="pe-7s-search" />
          </button>
        </form>
      </div>
    </div>
  );
}

export default MobileSearch;


